import { load } from "@cashfreepayments/cashfree-js";
import { useLocation } from "react-router-dom";

const CashfreePayButtonScreen = () => {
  const location = useLocation();
  const { orderResponse: paymentDetails } = location.state || {};
  let cashfree;
  // change mode to 'production' before going live, keep sandbox for testing
  var initializeSDK = async function () {
    cashfree = await load({
      mode: "production",
    });
  };
  initializeSDK();
  // console.log("inside CashfreePayButtonScreen");
  // console.log(paymentDetails);
  const doPayment = async () => {
    let checkoutOptions = {
      paymentSessionId: paymentDetails.cashfreePaymentSessionId,
      redirectTarget: "_self",
    };
    cashfree.checkout(checkoutOptions);
  };

  return (
    <div class="row" style={{ margin: "5rem 1rem" }}>
      <p>Click below to open the checkout page in current tab</p>
      <strong style={{ margin: "1rem" }}>
        Amount : {paymentDetails?.grossTotal}{" "}
      </strong>
      <button
        style={{ margin: "1rem" }}
        type="submit"
        class="btn btn-primary"
        id="renderBtn"
        onClick={doPayment}
      >
        Pay Now
      </button>
    </div>
  );
};
export default CashfreePayButtonScreen;
